// material ui
import { Theme } from '@mui/material';

export const dialogCustomization = {
  MuiDialog: {
    styleOverrides: {
      // This is the "paper" slot (the white card part of the dialog)
      paper: ({ theme }: { theme: Theme }) => ({
        backgroundColor:
          theme.palette.mode === 'light'
            ? theme.palette.grey[50]
            : theme.palette.grey[1000],
        borderRadius: '6px',
        border: '1px solid ' + theme.palette.divider,
        backgroundImage: 'none',
      }),
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        ...theme.typography.subtitle1,
        '& .MuiTypography-root': {
          ...theme.typography.subtitle1,
        },
      }),
    },
  },

  MuiDialogContent: {
    defaultProps: {
      dividers: true,
    },
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        ...theme.typography.body2,
      }),
      dividers: ({ theme }: { theme: Theme }) => ({
        borderTopColor: theme.palette.divider,
        borderBottomColor: theme.palette.divider,
      }),
    },
  },
};
